import { UserType } from '../../models/enums/user-type.enum';
import { FeatureFlagConstant } from './featuerFlag-contstant';

export class SideBarMenu {
  public static DROPDOWNS = {
    orders: false,
    projects: false,
    inspectors: false,
    coupons: false,
    notificatios: false,
    company: false,
    sopra: false,
  };

  public static SIDEBAR_MENU_DATA = {
    [UserType.Admin]: [
      {
        sideItem: 'الرئيسية',
        imgIcon: 'assets/images/svg/home.svg',
        pageTile: 'الرئيسية | عاين',
        sidebarstatus: 'home',
        url: '',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'الطلبات',
        imgIcon: 'assets/images/svg/orders.svg',
        pageTile: 'الطلبات | عاين',
        sidebarstatus: 'orders',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'الطلبات المعتمدة',
            pageTile: 'الطلبات | عاين',
            sidebarstatus: 'orders',
            url: '/pages/orders/orders-list',
          },
        ],
      },
      {
        sideItem: 'العملاء',
        imgIcon: 'assets/images/svg/account.svg',
        pageTile: 'العملاء | عاين',
        sidebarstatus: 'customers',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'العملاء ',
            pageTile: 'العملاء | عاين',
            sidebarstatus: 'customers-grid',
            url: '/pages/customers/customers-grid',
          },
          {
            item: 'تقيمات العملاء',
            pageTile: 'تقيمات العملاء  | عاين',
            sidebarstatus: 'customers-rating',
            url: '/pages/customers/customers-rating',
          },
        ],
      },
      {
        sideItem: 'الوحدات العقارية',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: 'الوحدات العقارية | عاين',
        sidebarstatus: 'property-units',
        url: '/pages/property-units',
        isSubMenu: false,
        subMenuItems: [],
        featureFlag: FeatureFlagConstant.ADMIN_PROPERTY_UNIT,
      },
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'طلبات المشاريع',
            pageTile: ' طلبات المشاريع | عاين',
            sidebarstatus: 'projects',
            url: '/pages/projects/orders',
          },
          {
            item: 'العقود التجارية',
            pageTile: 'العقود التجارية | عاين',
            sidebarstatus: 'projects-list',
            url: '/pages/projects/list',
          },
          {
            item: 'التقييم التلقائي للفحوصات ',
            pageTile: 'التقييم التلقائي للفحوصات  | عاين',
            sidebarstatus: 'evaluations',
            url: '/pages/projects/evaluations',
          },
        ],
      },
      {
        sideItem: 'ادارة المجتمعات',
        imgIcon: 'assets/images/svg/shopping-cart.svg',
        pageTile: 'ادارة المجتمعات | عاين',
        sidebarstatus: 'community',
        url: '/pages/community',
        isSubMenu: false,
        subMenuItems: [],
        featureFlag: FeatureFlagConstant.COMMUNITY_FEATURE,
      },
      {
        sideItem: 'تسعير الباقات',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: 'تسعير الباقات | عاين',
        sidebarstatus: 'pricing',
        url: '/pages/pricing/list',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'الخدمات',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: 'الخدمات | عاين',
        sidebarstatus: 'services',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'جميع الخدمات ',
            pageTile: ' الخدمات  | عاين',
            sidebarstatus: 'services',
            url: '/pages/services/list',
          },
          {
            item: 'ادارة التقييمات',
            pageTile: 'ادارة التقييمات | عاين',
            sidebarstatus: 'evaluations-management',
            url: '/pages/evaluations-management',
            featureFlag: FeatureFlagConstant.ADMIN_EVALUATION,
          },
          {
            item: 'الإضافات',
            pageTile: '  الإضافات | عاين',
            sidebarstatus: 'additionals',
            url: '/pages/services/additions',
          },
          {
            item: 'الشروط والأحكام',
            pageTile: '  الشروط والأحكام | عاين',
            sidebarstatus: 'terms-conditions',
            url: '/pages/services/terms-conditions',
          },
        ],
      },
      {
        sideItem: 'الشركات',
        imgIcon: 'assets/images/svg/company-icon.svg',
        pageTile: 'الشركات | عاين',
        sidebarstatus: 'company',
        url: '/pages/company/list',
        isSubMenu: false,
        subMenuItems: [
          {
            item: 'الشركات',
            pageTile: 'الشركات | عاين',
            sidebarstatus: 'company',
            url: '/pages/company/list',
          },
          {
            item: 'أعضاء الشركة',
            pageTile: 'أعضاء الشركة | عاين',
            sidebarstatus: 'company-team-list',
            url: '/pages/company/company-team-list',
          },
          {
            item: 'الأدوار و الأذونات',
            pageTile: 'الأدوار و الأذونات | عاين',
            sidebarstatus: 'company-roles',
            url: '/pages/company/company-roles',
          },
          {
            item: 'المشاريع العقارية',
            pageTile: 'المشاريع العقارية | عاين',
            sidebarstatus: 're-projects',
            url: '/pages/re-projects',
          },
        ],
      },
      {
        sideItem: 'الفاحصين',
        imgIcon: 'assets/images/svg/inspector.svg',
        pageTile: '',
        sidebarstatus: 'inspectors',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'جميع الفاحصين',
            pageTile: 'الفاحصين | عاين',
            sidebarstatus: 'inspectors-grid',
            url: '/pages/inspectors/inspectors-grid',
          },
          {
            item: 'التأهيل',
            pageTile: 'المؤهلين | عاين',
            sidebarstatus: 'qualified-grid',
            url: '/pages/inspectors/qualified',
          },
          {
            item: ' احصائيات الفاحصين',
            pageTile: 'احصائيات الفاحصين | عاين',
            sidebarstatus: 'inspectors-settings',
            url: '/pages/inspectors/inspectors-statistics',
          },
          {
            item: ' اعدادات الفاحصين',
            pageTile: 'اعدادات الفاحصين | عاين',
            sidebarstatus: 'inspectors-stats',
            url: '/pages/inspectors/settings',
          },
        ],
      },
      {
        sideItem: 'مدققين الجودة',
        imgIcon: 'assets/images/svg/inspector.svg',
        pageTile: 'مدققين الجودة | عاين',
        sidebarstatus: 'qc',
        url: '/pages/qc/list',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'سوبرا',
        imgIcon: 'assets/images/svg/inspector.svg',
        pageTile: '',
        sidebarstatus: 'sopra',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'المتقدمين لسوبرا',
            pageTile: 'سوبرا | عاين',
            sidebarstatus: 'sopra-grid',
            url: '/pages/sopra/sopra-profile',
          },
          {
            item: 'المتقدمين لعاين',
            pageTile: 'سوبرا | عاين',
            sidebarstatus: 'ayen-grid',
            url: '/pages/sopra/ayen-profile',
          },
          {
            item: 'طلبات سوبرا',
            pageTile: 'طلبات سوبرا | عاين',
            sidebarstatus: 'sopra-orders',
            url: '/pages/orders/orders-list/sopra',
          },
          {
            item: 'قائمة خدمات سوبرا',
            pageTile: 'قائمة خدمات سوبرا | عاين',
            sidebarstatus: 'sopra-services-list',
            url: '/pages/sopra/services',
          },
          {
            item: 'خدمات سوبرا',
            pageTile: 'خدمات سوبرا | عاين',
            sidebarstatus: 'sopra-services',
            url: '/pages/services/list/sopra',
          },
          {
            item: 'باقات سوبرا',
            pageTile: 'باقات سوبرا | عاين',
            sidebarstatus: 'sopra-packages',
            url: '/pages/pricing/list/sopra',
          },
          {
            item: 'طلبات المتقدمين لخدمات سوبرا',
            pageTile: 'طلبات المتقدمين لخدمات سوبرا | عاين',
            sidebarstatus: 'services-requests',
            url: '/pages/sopra/services-requests',
          },
        ],
      },
      {
        sideItem: 'إعدادت الخدمات',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'service-scopes',
        url: '',
        beta: true,
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'نطاقات الخدمات',
            pageTile: 'نطاقات الخدمات | عاين',
            sidebarstatus: 'service-scopes',
            url: '/pages/capabilities',
          },
        ],
      },
      {
        sideItem: 'Tags',
        imgIcon: 'assets/images/svg/tag.svg',
        pageTile: 'Tags | عاين',
        sidebarstatus: 'service-tags',
        url: '/pages/service-tags/tags-list',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'أكواد الخصم',
        imgIcon: 'assets/images/svg/descount.svg',
        pageTile: '',
        sidebarstatus: 'coupons',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'جميع الأكود',
            pageTile: 'اكواد | الخصم',
            sidebarstatus: 'coupon-list',
            url: '/pages/coupons/copoun-list',
          },
          {
            item: 'البطاقات البنكية',
            pageTile: 'البطاقات البنكية | عاين',
            sidebarstatus: 'bank-list',
            url: '/pages/coupons/bank-list',
          },
        ],
      },
      {
        sideItem: 'تحديثات النظام',
        imgIcon: 'assets/images/svg/whats-new.svg',
        pageTile: 'تحديثات النظام | عاين',
        sidebarstatus: 'whats-new',
        url: '/pages/whats-new/whats-new-grid',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'مركز الإشعارات',
        imgIcon: 'assets/images/svg/NOTIFICATION-s.svg',
        pageTile: '',
        sidebarstatus: 'notificatios',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'إشعارات داخلية',
            pageTile: 'مركز الإشعارات | عاين',
            sidebarstatus: 'notification-list',
            url: '/pages/notification-center/notification-list',
          },
          {
            item: 'إشعارات المستعرض',
            pageTile: 'مركز الإشعارات | عاين',
            sidebarstatus: 'notificationBrowser-list',
            url: '/pages/notification-center/notification-list/true',
          },
        ],
      },
     
    ],
    [UserType.FINANCE]: [
      {
        sideItem: 'المالية',
        imgIcon: 'assets/images/svg/home.svg',
        pageTile: 'المالية | عاين',
        sidebarstatus: 'finance',
        url: '/pages/finance',
        isSubMenu: false,
        subMenuItems: [],
      },
    ],
    [UserType.Markting]: [
      {
        sideItem: 'رسائل نصية',
        imgIcon: 'assets/images/svg/home.svg',
        pageTile: 'رسائل نصية | عاين',
        sidebarstatus: 'sms',
        url: 'pages/markting/send-sms',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'الخدمات',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: 'الخدمات | عاين',
        sidebarstatus: 'services',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'جميع الخدمات ',
            pageTile: ' الخدمات  | عاين',
            sidebarstatus: 'services',
            url: '/pages/services/list',
          },
        ],
      },
    ],
    [UserType.Assistant]: [
      {
        sideItem: 'الطلبات',
        imgIcon: 'assets/images/svg/orders.svg',
        pageTile: 'الطلبات | عاين',
        sidebarstatus: 'orders',
        url: '/pages/orders/orders-list',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'طلبات المشاريع',
            pageTile: ' طلبات المشاريع | عاين',
            sidebarstatus: 'projects',
            url: '/pages/projects/orders',
          },
        ],
      },
    ],
    [UserType.Supervisor]: [
      {
        sideItem: 'الرئيسية',
        imgIcon: 'assets/images/svg/home.svg',
        pageTile: 'الرئيسية | عاين',
        sidebarstatus: 'home',
        url: '',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'الطلبات',
        imgIcon: 'assets/images/svg/orders.svg',
        pageTile: 'الطلبات | عاين',
        sidebarstatus: 'orders',
        url: '/pages/orders/orders-list',
        isSubMenu: false,
        subMenuItems: [],
      },
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'طلبات المشاريع',
            pageTile: ' طلبات المشاريع | عاين',
            sidebarstatus: 'projects',
            url: '/pages/projects/orders',
          },
          {
            item: 'العقود التجارية',
            pageTile: 'العقود التجارية | عاين',
            sidebarstatus: 'projects-list',
            url: '/pages/projects/list',
          },
        ],
      },
      {
        sideItem: 'العملاء',
        imgIcon: 'assets/images/svg/account.svg',
        pageTile: 'العملاء | عاين',
        sidebarstatus: 'customers',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'تقيمات العملاء',
            pageTile: 'تقيمات العملاء  | عاين',
            sidebarstatus: 'customers-rating',
            url: '/pages/customers/customers-rating',
          },
        ],
      },
      {
        sideItem: 'الوحدات العقارية',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: 'الوحدات العقارية | عاين',
        sidebarstatus: 'property-units',
        url: '/pages/property-units',
        isSubMenu: false,
        subMenuItems: [],
        featureFlag: FeatureFlagConstant.ADMIN_PROPERTY_UNIT,
      },
      {
        sideItem: 'الفاحصين',
        imgIcon: 'assets/images/svg/inspector.svg',
        pageTile: '',
        sidebarstatus: 'inspectors',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'جميع الفاحصين',
            pageTile: 'الفاحصين | عاين',
            sidebarstatus: 'inspectors-grid',
            url: '/pages/inspectors/inspectors-grid',
          },
          {
            item: 'التأهيل',
            pageTile: 'المؤهلين | عاين',
            sidebarstatus: 'qualified-grid',
            url: '/pages/inspectors/qualified',
          },
          {
            item: ' احصائيات الفاحصين',
            pageTile: 'احصائيات الفاحصين | عاين',
            sidebarstatus: 'inspectors-settings',
            url: '/pages/inspectors/inspectors-statistics',
          },
          {
            item: ' اعدادات الفاحصين',
            pageTile: 'اعدادات الفاحصين | عاين',
            sidebarstatus: 'inspectors-stats',
            url: '/pages/inspectors/settings',
          },
        ],
      },
    ],
    [UserType.OrderDataEntry]: [
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'طلبات المشاريع',
            pageTile: ' طلبات المشاريع | عاين',
            sidebarstatus: 'projects',
            url: '/pages/projects/orders',
          },
        ],
      },
    ],
    [UserType.AssignmentOffice]: [
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'العقود التجارية',
            pageTile: 'العقود التجارية | عاين',
            sidebarstatus: 'projects-list',
            url: '/pages/projects/list',
          },
          {
            item: 'طلبات المشاريع',
            pageTile: ' طلبات المشاريع | عاين',
            sidebarstatus: 'projects',
            url: '/pages/projects/orders',
          },
        ],
      },
    ],
    [UserType.InspectorActivationOffice]: [
      {
        sideItem: 'الفاحصين',
        imgIcon: 'assets/images/svg/inspector.svg',
        pageTile: '',
        sidebarstatus: 'inspectors',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'جميع الفاحصين',
            pageTile: 'الفاحصين | عاين',
            sidebarstatus: 'inspectors-grid',
            url: '/pages/inspectors/inspectors-grid',
          },
        ],
      },
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'العقود التجارية',
            pageTile: 'العقود التجارية | عاين',
            sidebarstatus: 'projects-list',
            url: '/pages/projects/list',
          },
        ],
      },
    ],
    [UserType.SupervisorQC]: [
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'طلبات المشاريع',
            pageTile: ' طلبات المشاريع | عاين',
            sidebarstatus: 'projects',
            url: '/pages/projects/orders',
          },
        ],
      },
    ],
    [UserType.QC]: [
      {
        sideItem: 'المشاريع',
        imgIcon: 'assets/images/svg/projects.svg',
        pageTile: '',
        sidebarstatus: 'projects',
        url: '',
        isSubMenu: true,
        subMenuItems: [
          {
            item: 'طلبات المشاريع',
            pageTile: ' طلبات المشاريع | عاين',
            sidebarstatus: 'projects',
            url: '/pages/projects/orders',
          },
        ],
      },
    ],
  };
}
